<template>
  <div class="animated fadeIn" :key="segmentID">
    <b-row>
      <b-col :cols="12" :md="6">
        <filter-input 
          v-model="filter"
          :collection_value="dataType.indexOf('.csv') > -1 ? rawFile['_id'] : dataType"
          :segment-i-d="segmentID"
          :project-i-d="projectID"
          :meta="meta"
          :view="view"/>
      </b-col>
      <b-col :cols="12" :md="6" class="text-right">
        <b-form-group style="margin-top:34px;">
          <b-form-radio-group
            v-model="view"
            :options="[
                {value: 'insights', text: 'INSIGHTS'},
                {value: 'list', text: 'RECORDS'},
                {value: 'derived_features', text: 'SCORECARD'}
              ]"
            buttons
            button-variant="outline-light"
            button-bg="white"/>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="py-3">
      <div class="animated fadeIn" v-if="view === 'insights'">
        <secondary-data-tab
          :active="active && view === 'insights'"
          :raw-file="rawFile"
          :data-type="dataType.indexOf('.csv') > -1 ? rawFile['_id'] : dataType"
          :database="database"
          :filter="filter"/>
      </div>
      <div class="animated fadeIn" v-else-if="view === 'derived_features'">
          <agents-list
            class="mb-2; mt-2"
             action-text="view"
            :enableAction=false
            
            :enableFilter=true
            :values="list_view_insights"
            :filter="filter"
            :active="active && view === 'derived_features'"
            :rowCount="list_view_insights.length"
            :defaultColumns="defaultCols"
            >

          </agents-list>
      </div>
    
    <div class="animated fadeIn" v-else-if="view === 'list'">
      <customer-list-section
        :filter="filter"
        :active="active && view === 'list'"
        :raw-file="rawFile"
        :database="database"
        :data-type="dataType.indexOf('.csv') > -1 ? rawFile['_id'] : dataType" />
    </div>
    </div>
  </div>
</template>

<script>
  import FilterInput from './FilterInput';
  import CustomerListSection from './CustomerListSection';
  import SecondaryDataTab from './SecondaryDataTab';
  import axios from "axios";
  import { fullURL } from "../../utils"
	import {registerListener, unregisterListener} from '../../tasks';

  import AgentsList from "../CustomReportsManager/AgentsList"
  export default {
    name: 'Insights',

    components: {
      FilterInput,
      SecondaryDataTab,
      CustomerListSection,
      AgentsList
    },

    props: {
      segmentID: String,
      projectID: String,
      meta: String,
      active: Boolean,
      rawFile: Object,
      dataType: String,
      database: String
    },

  //  created(){
     
  //     axios.get(
  //     fullURL(`/credit_score/${this.rawFile['_id']}`)
  //   ).then(({data}) => {
  //       // this.list_view_insights = data[0].data;
  //       // this.defaultCols = data[0].defaultCols;
  //       this.monitorTask(data)

  //     }
  //   )
  //   },

    mounted() {
      axios.get(
      fullURL(`/credit_score/${this.rawFile['_id']}`)
    ).then(({data}) => 
        // this.list_view_insights = data[0].data;
        // this.defaultCols = data[0].defaultCols;
        this.monitorTask(data)
      
    ).catch(e => {
						console.log(e);
					
      });
          
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'));
      });
    },

    data() {
      const {view} = this.$route.query;

      return {
        // view: view === "list" ? view : 'insights',
        view: view === "list"?view:(view==="derived_features"?view:'insights'),
        // view: "insights",
        disableScorecard: true,
        defaultCols: null,
        send_email:null,
        list_view_insights:[],
        filter: {
          method: undefined,
          values: undefined
        }
      };
    },
    computed:{
      user() {
        return this.$store.state.general.user;
      }
    },
    methods:{
      	monitorTask(taskID) {
				console.log("CreditScore: Monitor credit score task");
        
				registerListener(taskID, (event, data) => {
					if (event === 'success') {
            console.log("The credit scores are generated",);
            console.log("the data is", data);

            this.list_view_insights = data.results.data;
            this.defaultCols = data.results.defaultCols;
            this.send_email = data.results.send_email;

            this.makeToast('success');
            if (this.send_email){
              axios.get(
                fullURL(`/credit_score/email/${this.user.email}`)
              ).then(
                console.log('credit scores email sent!')
              ).catch(e => {
                console.log(e);
              });

            }
            

            this.disableScorecard = false;
					} else if (event === 'failure') {
						console.log('The process failed', data.message);
					} else {
						return;
					}

					unregisterListener(taskID);
				});
      },
      
        makeToast(variant = null) {
        this.$bvToast.toast('Credit Scores Generated', {
          title:'Successful',
          autoHideDelay: 5000000,
          variant: variant,
          solid: true
        })
      }
    }

  };
</script>

<style>
  .content {
    border: none !important;
    background-color: #e4e5e6;
    margin: 0;
    margin-left: -12px !important;
    margin-right: -12px !important;
  }
</style>
